import ArrowButtonHome from "~/assets/icons/ArrowButtonHome";
import { bigBannerBottom } from "../../../setup/settings/__home";

export function BigBannerBottom() {
  return (
    <div className="bigBannerBottom__container">
      <div className="bigBannerBottom__grid grid md:grid-cols-2 sm:grid-cols-1 gap-0">

        <div className="bigBannerBottom__leftArea">
          <div className="bigBannerBottom__textContainer">
            <p className='bigBannerBottom__smallText'>{bigBannerBottom.smallText}</p>
            <p className='bigBannerBottom__title'>{bigBannerBottom.title}</p>
            <p className='bigBannerBottom__description'>{bigBannerBottom.description}</p>
            <a className="bigBannerBottom__btn" href={`${bigBannerBottom.href}`}><button>{bigBannerBottom.textButton}</button><ArrowButtonHome /></a>
          </div>
        </div>

        <div className="bigBannerBottom__rightArea">
          <div className="bigBannerBottom__imgContainer">
            <img src={bigBannerBottom.imageUrl} />
          </div>
        </div>
      </div>

    </div>
  );
};